import { useTranslation } from 'react-i18next';
import { getProviderCompliance } from '../../payments/providerCompliance';
import './PaymentProviderBanner.scss';

interface PaymentProviderBannerProps {
  techid: string | null | undefined;
  className?: string;
}

/**
 * Provider-mandated logo strip ("banner") for a payment provider, rendered
 * standalone in close proximity to the payment methods. Today that is Barion's
 * Smart Payment Banner, which Barion requires — unmodified — on the shop's
 * main page and payment page(s) before approving the shop for live payments.
 *
 * Renders nothing for providers without a `banner` in their compliance
 * descriptor. The image links to the provider's info page when one exists.
 */
const PaymentProviderBanner = ({ techid, className }: PaymentProviderBannerProps) => {
  const { i18n } = useTranslation();
  const compliance = getProviderCompliance(techid);
  if (!compliance?.banner) return null;

  const img = <img src={compliance.banner.src} alt={compliance.banner.alt} />;
  return (
    <div className={['payment-provider-banner', className].filter(Boolean).join(' ')}>
      {compliance.infoLink ? (
        <a href={compliance.infoLink(i18n.language)} target="_blank" rel="noopener noreferrer">
          {img}
        </a>
      ) : (
        img
      )}
    </div>
  );
};

export default PaymentProviderBanner;
